module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-guardian.74f039115fe9a5f6a326ee1f8c8c91cd.png";